import { ErrorHandler, LOCALE_ID } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { TranslateService } from '@ngx-translate/core';
import { NgxPermissionsService } from 'ngx-permissions';
import { NgbDateParserFormatter, NgbDateAdapter } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateCustomParserFormatter } from '@shared/helpers/ngb-date-custom-parser-formatter';
import { NgbDateStringAdapter } from '@shared/helpers/ngb-date-string-adapter';

import { BasicAuthInterceptor, ErrorInterceptor } from '@shared/interceptors';
import { DynamicLocaleId } from '@shared/helpers/dynamic-locale-id';
import { CustomNgxPermissionsService } from '@shared/services/custom-ngx-permissions.service';
import { GlobalErrorHandler } from '@shared/helpers/global-error-handler';
import { APP_BASE_HREF } from '@angular/common';

export const providers = [
    StatusBar,
    SplashScreen,
    Title,
    { provide: APP_BASE_HREF, useValue: '/' },
    { provide: LOCALE_ID, useClass: DynamicLocaleId, deps: [TranslateService]},
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: BasicAuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: NgxPermissionsService, useClass: CustomNgxPermissionsService },
    { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter },
    { provide: NgbDateAdapter, useClass: NgbDateStringAdapter },
];